<div class="row">
  <h5 class="px-0 col-12 zero-text p-small-bold mt-4 mb-3">
    {{ 'user-self-service.dividend-re-invest.headline' | transloco | uppercase }}
  </h5>
  <div class="px-0 col-12 d-md-flex justify-content-between align-items-center">
    <p class="zero-text p-base-reg mb-0">{{ 'user-self-service.dividend-re-invest.label' | transloco }}</p>
    <ng-container *ngTemplateOutlet="toggles; context: { currentSettings: facade.currentSettings$ | async }" />
  </div>
  @if (facade.hasChosen$ | async) {
    <p class="zero-text p-small-reg course-green mt-3">{{ 'user-self-service.dividend-re-invest.success' | transloco }}</p>
  }
  @if (facade.error$ | async; as error) {
    <p class="zero-text p-small-reg course-red mt-3">{{ error }}</p>
  }
</div>

<ng-template #toggles let-currentSettings="currentSettings">
  <div class="toggle-switch">
    <button
      [class.active]="currentSettings?.doReinvest && currentSettings?.amountFrom === 1"
      [disabled]="facade.hasOngoingRequest$ | async"
      (click)="openModal(modalContent, currentSettings, 1)"
    >
      {{ 'user-self-service.dividend-re-invest.yes-1' | transloco }}
    </button>
    <button
      [class.active]="currentSettings?.doReinvest && currentSettings?.amountFrom === 25"
      [disabled]="facade.hasOngoingRequest$ | async"
      (click)="openModal(modalContent, currentSettings, 25)"
    >
      {{ 'user-self-service.dividend-re-invest.yes-25' | transloco }}
    </button>
    <button
      [class.active]="currentSettings && !currentSettings.doReinvest"
      [disabled]="facade.hasOngoingRequest$ | async"
      (click)="facade.decline()"
    >
      {{ 'user-self-service.dividend-re-invest.no' | transloco }}
    </button>
  </div>
</ng-template>

<ng-template #modalContent let-modal>
  <web-design-system-modal [headline]="'user-self-service.dividend-re-invest.headline' | transloco" (dismiss)="modal.dismiss()">
    <p class="zero-text p-base-reg" [innerHTML]="'my-home.my-home-page.dividend-re-invest-hint.text' | transloco"></p>
    <div class="checkbox-container">
      <web-design-system-checkbox [isChecked]="false" (isCheckedChange)="isCheckboxChecked = $event">
        <span class="zero-text p-big-med" [innerHTML]="'my-home.my-home-page.dividend-re-invest-hint.checkbox' | transloco"> </span>
      </web-design-system-checkbox>
    </div>
    @if (facade.error$ | async; as error) {
      <p class="zero-text course-red">{{ error }}</p>
    }
    <div class="mt-4 action-container d-flex flex-column flex-xl-row justify-content-xl-end align-items-center">
      <web-design-system-button
        type="primary"
        size="small"
        [disabled]="(facade.hasOngoingRequest$ | async) || !isCheckboxChecked"
        (click)="facade.activate(chosenAmountFrom); modal.dismiss()"
      >
        {{ 'my-home.my-home-page.dividend-re-invest-hint.actions.yes' | transloco: { value: chosenAmountFrom } }}
      </web-design-system-button>
    </div>
  </web-design-system-modal>
</ng-template>
